/**
 * 内容区链接的打开方式：必须按住 Ctrl(Win) / Command(Mac) 才跳转
 *
 * 内容单元格大多是 contentEditable，直接点击链接应该只放光标、不跳转，
 * 否则编辑时很容易误触。这里统一用一个 document 级的委托监听处理。
 */

const isMac = typeof navigator !== 'undefined' &&
    /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent || '')

/** 当前平台的修饰键名，用于提示文案 */
export const MODIFIER_KEY = isMac ? 'Command' : 'Ctrl'

/** 链接 title 上的提示文案，同时给 formatText 生成 HTML 时使用 */
export const MODIFIER_HINT = `按住 ${MODIFIER_KEY} 点击打开链接`

/** 内容区链接的选择器，表格单元格与 TODO 区域 */
const CONTENT_LINK_SELECTOR = '.ne-td a[href], .ne-edit a[href], .container-todo a[href]'

const handleClick = (e) => {
    // 鼠标中键、右键交给浏览器默认行为
    if (e.button !== 0) return

    const link = e.target.closest?.(CONTENT_LINK_SELECTOR)
    if (!link) return

    e.preventDefault()

    if (!(e.ctrlKey || e.metaKey)) return

    const href = link.getAttribute('href')
    if (!href) return
    window.open(href, '_blank', 'noopener,noreferrer')
}

/**
 * 注册内容区链接的点击拦截，返回解绑函数
 * @returns {() => void}
 */
export const registerContentLinkClick = () => {
    document.addEventListener('click', handleClick)
    return () => {
        document.removeEventListener('click', handleClick)
    }
}
